export const getWorldpayStatus = (state) => state.worldpay?.isWorldpayOpen || false;
export const getCardAddedStatus = (state) => state.worldpay?.isCardAdded || false;

export default {};